import axios from 'axios';
import "@/apis/index.js";

export const getReferralRewards = (currency, userType) => axios.get(`/billing/refer/rewards?currency=${currency}&userType=${userType}`);

export const isReferralEligible = (referralCode, country, currency) => axios.get(`/opc/refer/isReferralEligible?referralCode=${encodeURIComponent(referralCode)}&country=${country}&currency=${currency}`);
